module.exports = __webpack_public_path__ + "img/vidjet-logo.57e256ac.png";